import React, {useState} from "react"
import './App.css';
import {BrowserRouter as Router, Switch, Route} from "react-router-dom"
import Navbar from "./Component/Navbar/Navbar";
import Home from "./Pages/Home";
import Sidebar from "./Component/Sidebar/Sidebar";
import Footers from "./Component/Footer/Footers"
import MyService from "./Pages/MyService";
import SignUp from "./Pages/SignUp";
import About from "./Pages/About";
import Loginn from "./Pages/Loginn";
import MyContact from "./Pages/MyContact";



function App() {
  const [isOpen, setIsOpen] = useState(false);

    const toggle = ()=>{
        setIsOpen(!isOpen)
    }


  return (
   
    <Router>
    
      <Sidebar isOpen={isOpen} toggle={toggle}/>
      <Navbar toggle={toggle} />
      <Switch>
        <Route  exact path="/" component={Home}/>
        <Route exact path="/services" component={MyService}/>
        <Route exact path="/sign-up" component={SignUp}/>    
        <Route exact path="/about" component={About}/>
        <Route exact path="/login" component={Loginn}/>

        <Route exact path="/contacts" component={MyContact}/>
        
    
      </Switch>
      <Footers/>
    </Router>
    

  );
    
    
}

export default App;
